/** 小程序消息模板API */
import type { Api } from '@/typings/api';
import { download, post } from '../../request';
const prefix = '/sys/miniAppTemplate';
/**
 * 分页查询小程序消息模板
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Sys.MiniAppTemplate> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询小程序消息模板列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Sys.MiniAppTemplate> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个小程序消息模板
 *
 * @param id 小程序消息模板ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Sys.MiniAppTemplate> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存小程序消息模板
 *
 * @param params 小程序消息模板信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新小程序消息模板信息
 *
 * @param params 小程序消息模板信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除小程序消息模板
 *
 * @param id 小程序消息模板ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除小程序消息模板
 *
 * @param ids 小程序消息模板ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params, 'XXXXX.xlsx');
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  doExport
};
